var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const SvgChevronRight = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size || 24, height: size || 24, viewBox: "0 0 24 24", role: props.role, "aria-hidden": props['aria-hidden'] || true }, props),
        React.createElement("path", { fill: props.color || 'currentColor', fillRule: "evenodd", d: "M9.46966991,17.4696699 C9.1767767,17.7625631 9.1767767,18.2374369 9.46966991,18.5303301 C9.76256313,18.8232233 10.2374369,18.8232233 10.5303301,18.5303301 L16.5303301,12.5303301 C16.8232233,12.2374369 16.8232233,11.7625631 16.5303301,11.4696699 L10.5303301,5.46966991 C10.2374369,5.1767767 9.76256313,5.1767767 9.46966991,5.46966991 C9.1767767,5.76256313 9.1767767,6.23743687 9.46966991,6.53033009 L14.9393398,12 L9.46966991,17.4696699 Z" })));
};
export default SvgChevronRight;
